<template>
  <li class="track-item event-item" @click="$emit('select', event.id)">
    <div class="track-item-title">{{ event.name }}</div>
    <div class="track-item-meta">
      {{ formatEventDateRange(event.starts_at, event.ends_at) }} · {{ visibilityLabel(event.public) }}
    </div>
    <div v-if="event.author" class="track-item-meta">
      {{ event.participants_count ?? 0 }} участников ·
      {{ event.likes_count ?? 0 }} 👍 · {{ event.comments_count ?? 0 }} 💬
    </div>
    <div v-if="event.organizers?.length" class="track-item-meta track-item-author event-organizers">
      <span>{{ event.organizers.length > 1 ? 'Организаторы' : 'Организатор' }}:</span>
      <template v-for="(organizer, index) in visibleOrganizers" :key="organizerKey(organizer, index)">
        <span v-if="index > 0">, </span>
        <AuthorLink
          v-if="organizer.kind === 'user'"
          :author="organizer.user"
          size="sm"
          stop-propagation
        />
        <span v-else>{{ organizer.name }}</span>
      </template>
      <span v-if="hiddenOrganizersCount"> ещё {{ hiddenOrganizersCount }}</span>
    </div>
    <div v-else-if="event.author" class="track-item-meta track-item-author">
      <AuthorLink :author="event.author" prefix="Организатор:" size="sm" stop-propagation />
    </div>
    <div v-if="showDelete" class="btn-row" style="margin-top: 0.75rem">
      <button class="btn btn-danger" @click.stop="$emit('delete', event.id)">
        Удалить
      </button>
    </div>
  </li>
</template>

<script setup>
import { computed } from 'vue'
import AuthorLink from './AuthorLink.vue'
import { formatEventDateRange, visibilityLabel } from '../utils/eventFormat'

const props = defineProps({
  event: {
    type: Object,
    required: true,
  },
  showDelete: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['select', 'delete'])

const visibleOrganizers = computed(() => {
  const organizers = props.event.organizers || []
  if (organizers.length <= 2) return organizers
  return organizers.slice(0, 2)
})

const hiddenOrganizersCount = computed(() => {
  const total = props.event.organizers?.length || 0
  return total > 2 ? total - 2 : 0
})

function organizerKey(organizer, index) {
  if (organizer.kind === 'user') return `user-${organizer.user.id}`
  return `external-${organizer.id || index}`
}
</script>

<style scoped>
.event-organizers {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
}
</style>
